import React, { useRef, useCallback } from 'react'
import { CoreButton } from 'src/components/core'

export const MediaUploader = ({ onUpload, classes }) => {
  const inputFileRef = useRef()

  const handleFileChange = useCallback(
    event => {
      const file = event.target.files[0]
      if (file) {
        onUpload(file)
      }
    },
    [onUpload],
  )

  return (
    <>
      <CoreButton onClick={() => inputFileRef.current.click()}>
        Upload
      </CoreButton>
      <input
        type="file"
        ref={inputFileRef}
        onChange={handleFileChange}
        className={classes.imageUploadInput}
        accept="image/*"
      />
    </>
  )
}
